// const urlName = '/monitor/monitor/v1/user'
const urlName = '/monitor/v1/user'

export default API => ({
    judgefaceauth({ params, data }) {
        return API({ url: `${urlName}/oauth/isRealNameAuthentication`, method:'post', params, data });
    },//判断是否实名认证，不传参，返回data为true 已经实名, false为未实名。
    faceauthsuccess({ params, data }) {
        console.debug('aaa')
        return API({ url: `${urlName}/oauth/realNameAuthenticationSuccess`, method:'post', params, data });
    },//实名成功以后调用接口
})